import NaptimeResource from './NaptimeResource';

class DegreeLearnerMemberships extends NaptimeResource {
  static RESOURCE_NAME = 'degreeLearnerMemberships.v1';
}

export default DegreeLearnerMemberships;
